import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Anchor } from 'UI-Dash-Commons-UI';

export enum DocsPageAnchorType
{
    SMALL,
    REGULAR,
    LARGE,
}


interface DocsPageContentAnchorProps
{
    text: string,
    to: string,
    newWindow?: boolean,
    download?: string,
    size?: DocsPageAnchorType,
}

const DocsPageContentAnchor: FunctionComponent<DocsPageContentAnchorProps> = ({ text, to, newWindow = true, download, size=DocsPageAnchorType.REGULAR, }) =>
{
    return <DocsPageContentAnchorWrapper
        text={text}
        href={to}
        download={download}
        target={newWindow ? '_blank' : ''}
        rel={newWindow ? 'noopener noreferrer' : ''}
        size={size}
    />;
};

export default DocsPageContentAnchor;

const DocsPageContentAnchorWrapper = styled( Anchor )<{ size: DocsPageAnchorType }>`
  font-size: inherit;
  font-size: ${props => props.size === DocsPageAnchorType.SMALL && '12px' };
  font-size: ${props => props.size === DocsPageAnchorType.REGULAR && '16px' };
  font-size: ${props => props.size === DocsPageAnchorType.LARGE && '18px' };

`;
